<p-accordion expandIcon="fa fa-angle-down" collapseIcon="fa fa-angle-up">
  <p-panel class="secondary-panel">
    <ng-template pTemplate="header">
      <div class="d-flex justify-content-between align-items-center flex-fill">
        <span>{{ accTabtitle }}</span>
        <span class="pe-5"
          >Total Income: <span class="totalIncome">{{ totalIncome$ | async | currency }}</span></span
        >
      </div>
    </ng-template>
    <p-panel #employmentIncome header="Employment Income" styleClass="mt-3" class="secondary-panel">
      <div class="row mb-3">
        <div class="col-12 form-group">
          <p-table class="expenses-table stack" [columns]="currentEmployersGridColumns" [value]="borrowerEmployers$ | async" breakpoint="325px">
            <ng-template pTemplate="header" let-columns>
              <tr>
                @for (col of columns; track col) {
                  <th [style]="{ width: col.width }" [ngClass]="{ 'actions-column': col.field === 'actions' }">
                    {{ col.header }}
                  </th>
                }
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="columns.length">
                  <div class="d-flex justify-content-center align-items-center title-text">No records found</div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
              <tr [ngClass]="{ 'row-selected': editing && +rowData['employmentId'] === editingId }">
                @for (col of columns; track col) {
                  <td [style]="{ width: col.width }" [ngClass]="{ 'actions-column': col.field === 'actions' }">
                    <span class="p-column-title fw-bold">{{ col.header }}</span>
                    @switch (col.field) {
                      @case ('employmentType') {
                        {{ getIncomeNamebyId(rowData['employmentType']) }}
                        @if (rowData['employmentType'] === 2) {
                          <span class="rounded-pill btn btn-primary btn-sm px-2 ms-2 fw-bold">Primary</span>
                        }
                      }
                      @case ('street') {
                        {{ rowData['street'] }}
                        @if (rowData['street'] && (rowData['city'] || (rowData['state'] && rowData['state'] !== '0') || rowData['zip'])) {
                          ,
                        }
                        {{ rowData['city'] }}
                        @if (rowData['city'] && rowData['state'] && rowData['state'] !== '0') {
                          ,
                        }
                        {{ rowData['state'] !== '0' ? rowData['state'] : '' }} {{ rowData['zip'] }}
                      }
                      @case ('dateFrom') {
                        {{ rowData['dateFrom'] | date: 'MM/dd/yyyy' }} -
                        @if (rowData['employmentType'] !== 0 || rowData['dateTo'] !== null) {
                          <span>{{ rowData['dateTo'] | date: 'MM/dd/yyyy' }}</span>
                        }
                        @if (rowData['dateTo'] === null || rowData['employmentType'] === 1 || rowData['employmentType'] === 2) {
                          <span>Present</span>
                        }
                      }
                      @case ('businessPhone') {
                        {{ formatPhone(rowData.businessPhone) }}
                      }
                      @case ('monthlyIncome') {
                        {{
                          rowData.employmentType === EmploymentStatus.Former
                            ? (rowData.monthlyIncome ?? 0 | currency)
                            : (getEmploymentIncome(rowData) | async | currency)
                        }}
                      }
                      @case ('additionalInfo') {
                        <div class="d-flex float-right">
                          <div>
                            <button
                              [disabled]="isFullyDisabled$ | async"
                              pButton
                              size="small"
                              [disabled]="editing && rowData.employmentId === editingId"
                              (click)="showPositionDialog('right', rowData.employmentId)"
                              severity="contrast"
                            >
                              view/edit
                            </button>
                          </div>
                          <div>
                            <p-button
                              severity="danger"
                              class="ms-1"
                              [disabled]="isFullyDisabled$ | async"
                              data-toggle="tooltip"
                              title="delete"
                              (click)="deleteBorrowerEmployer(rowData)"
                              icon="pi pi-trash"
                            />
                          </div>
                        </div>
                      }
                      @default {
                        {{ rowData[col.field] }}
                      }
                    }
                  </td>
                }
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
      <div class="d-flex">
        <button pButton [disabled]="isFullyDisabled$ | async" severity="secondary" size="small" class="mb-3" (click)="addEmployer()">
          <i class="pi pi-plus-circle me-3"></i><span>Add Employer</span>
        </button>
        <div class="ms-auto lead">
          Total Current Income: <span class="totalTitle">{{ (totalIncome$ | async) - (getTotalOtherIncome() | async) | currency }}</span>
        </div>
      </div>
    </p-panel>
    <p-panel #otherIncome header="Other Income" styleClass="mt-3" class="secondary-panel">
      <div class="row mb-3">
        <div class="col-12 form-group">
          <p-table
            #pt
            class="expenses-table stack"
            dataKey="incomeId"
            editMode="row"
            [columns]="currentOtherIncomeGridColumns"
            [value]="otherIncome$ | async"
            breakpoint="325px"
          >
            <ng-template pTemplate="header" let-columns>
              <tr>
                @for (col of columns; track col) {
                  <th [style]="{ width: col.width }" [ngClass]="{ 'actions-column': col.field === 'actions' }">
                    {{ col.header }}
                  </th>
                }
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="columns.length">
                  <div class="d-flex justify-content-center align-items-center title-text">No records found</div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-editing="editing" let-rowData let-columns="columns" let-ri="rowIndex">
              <tr editing="true" [pEditableRow]="rowData" [ngClass]="{ 'row-selected': editing && +rowData['incomeId'] === editingId }">
                @for (col of columns; track col) {
                  <td [style]="{ width: col.width }" [ngClass]="{ 'actions-column': col.field === 'actions' }">
                    <span class="p-column-title fw-bold">{{ col.header }}</span>
                    <div>
                      @switch (col.field) {
                        @case ('incomeType') {
                          <div>
                            <p-cellEditor>
                              <ng-template pTemplate="input">
                                <p-select
                                  class="w-100"
                                  [options]="otherIncomeTypes"
                                  [(ngModel)]="rowData[col.field]"
                                  [optionLabel]="'value'"
                                  [optionValue]="'id'"
                                  appendTo="body"
                                />
                              </ng-template>
                              <ng-template pTemplate="output">
                                <ng-container>
                                  {{ rowData[col.field] | toNameOrValue: otherIncomeTypes }}
                                </ng-container>
                              </ng-template>
                            </p-cellEditor>
                          </div>
                        }
                        @case ('amount') {
                          <div>
                            <p-cellEditor>
                              <ng-template pTemplate="input">
                                <div>
                                  <p-inputNumber
                                    data-private
                                    placeholder="$0.00"
                                    currency="USD"
                                    mode="currency"
                                    [max]="99999999999.99"
                                    maxlength="14"
                                    locale="en-US"
                                    id="amount"
                                    [(ngModel)]="rowData[col.field]"
                                  />
                                </div>
                              </ng-template>
                              <ng-template pTemplate="output">
                                <span>{{ rowData[col.field] | currency }} </span>
                              </ng-template>
                            </p-cellEditor>
                          </div>
                        }
                        @case ('actions') {
                          <div class="actions-column">
                            <div class="d-flex float-right">
                              <div class="me-2">
                                @if (!editing) {
                                  <p-button
                                    [disabled]="isFullyDisabled$ | async"
                                    pInitEditableRow
                                    type="button"
                                    (click)="onRowEditInit(rowData)"
                                    icon="pi pi-pencil"
                                  />
                                }
                                @if (editing) {
                                  <p-button
                                    [disabled]="isFullyDisabled$ | async"
                                    pSaveEditableRow
                                    type="button"
                                    (click)="onRowEditSave(rowData.applicationId, rowData)"
                                    icon="pi pi-check"
                                  />
                                }
                              </div>
                              <div>
                                @if (!editing) {
                                  <p-button
                                    [disabled]="isFullyDisabled$ | async"
                                    type="button"
                                    severity="danger"
                                    (click)="deleteOtherIncome(rowData)"
                                    icon="pi pi-trash"
                                  />
                                }
                                @if (editing) {
                                  <p-button
                                    [disabled]="isFullyDisabled$ | async"
                                    severity="danger"
                                    type="button"
                                    pCancelEditableRow
                                    (click)="onRowEditCancel(rowData)"
                                    icon="pi pi-times"
                                  />
                                }
                              </div>
                            </div>
                          </div>
                        }
                        @default {
                          <div>{{ col.field }}: {{ rowData[col.field] }}</div>
                        }
                      }
                    </div>
                  </td>
                }
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
      <div class="d-flex">
        <button pButton [disabled]="isFullyDisabled$ | async" type="button" severity="secondary" size="small" (click)="onNewClicked()">
          <i class="pi pi-plus-circle"></i>&nbsp;&nbsp;Add Other Income
        </button>
        <div class="ms-auto lead">
          Total Other Income: <span class="totalTitle">{{ getTotalOtherIncome() | async | currency }}</span>
        </div>
      </div>
      <div class="d-flex float-right">
        <div class="ms-auto lead">
          Net Rental Income:<span class="totalTitle">{{ netRentalIncome$ | async | currency }}</span>
        </div>
      </div>
    </p-panel>
  </p-panel>
</p-accordion>
<div #drawerContainer></div>
@if (borrower) {
  <p-drawer
    [(visible)]="displayPosition"
    position="right"
    [dismissible]="false"
    [closeOnEscape]="false"
    styleClass="editor-flyout"
    [appendTo]="drawerContainer"
    [closable]="false"
    [baseZIndex]="10000"
    (onHide)="closeModal()"
  >
    <ng-template pTemplate="header">
      <div class="d-flex w-100 align-items-center">
        <div class="h4 fw-bold mb-0 me-3">Employer for {{ borrower.firstName }} {{ borrower.lastName }}</div>
        <div class="ms-auto">
          <p-button
            icon="pi pi-times"
            type="button"
            class="p-drawer-close p-drawer-icon p-link"
            (click)="closeModal(); displayPosition = !displayPosition"
          />
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="content">
      <add-edit-employment-income
        class="d-flex flex-fill flex-column"
        [id]="id"
        [borrowerId]="borrowerId()"
        [isPrimaryBorrower]="borrower.isPrimaryBorrower"
        (editCancelled)="displayPosition = false"
      />
    </ng-template>
  </p-drawer>
}
